(function(){
  'use strict';
  function init(){
    document.querySelectorAll('[data-studio-header]').forEach(function(header){
      if(header.dataset.studioBound)return;
      header.dataset.studioBound='true';
      var menus=header.querySelectorAll('.studio-nav__dropdown,[data-studio-menu]');
      menus.forEach(function(menu){
        menu.addEventListener('toggle',function(){
          if(menu.open)menus.forEach(function(other){if(other!==menu)other.open=false});
        });
      });
      document.addEventListener('click',function(event){
        menus.forEach(function(menu){if(menu.open&&!menu.contains(event.target))menu.open=false});
      });
      header.addEventListener('keydown',function(event){
        if(event.key!=='Escape')return;
        menus.forEach(function(menu){if(menu.open){menu.open=false;menu.querySelector('summary').focus()}});
      });
      header.addEventListener('click',function(event){
        var link=event.target.closest('a');
        if(link)menus.forEach(function(menu){menu.open=false});
      });
    });

  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
